/**
 * Phone Number Input Mask
 *
 * Formats phone input as (###) ###-#### for North American numbers.
 */

/**
 * Format a raw string of digits into (###) ###-#### format.
 * Strips all non-digit characters first, then applies the mask progressively.
 */
export function formatPhoneNumber(value: string): string {
  // Strip everything except digits
  const digits = value.replace(/\D/g, '');

  // Limit to 10 digits
  const limited = digits.slice(0, 10);

  if (limited.length === 0) return '';
  if (limited.length <= 3) return `(${limited}`;
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
}

/**
 * Extract raw digits from a formatted phone string.
 */
export function unformatPhoneNumber(formatted: string): string {
  return formatted.replace(/\D/g, '');
}

/**
 * Check if a phone number has exactly 10 digits (complete North American number).
 */
export function isCompletePhoneNumber(value: string): boolean {
  return unformatPhoneNumber(value).length === 10;
}
